/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import CPSheetGeneralAnalyticsDash from "../../../../components/CPSheet/Analytics/General";
import Navbar from "../../../../components/Navbar";
import { backendUrlByEnv, LOGIN } from "../../../../constants/routes";

const CPSheetGeneralAnalytics = () => {
  const navigate = useNavigate();
  const { config: userConfig, env } = useSelector((state) => state?.reducer?.authInfo) || {};
  const ROOT_URL = backendUrlByEnv(env);
  useEffect(() => {
    if (!userConfig?.cpSheetAnalytics?.hasGeneralDashboardAccess) {
      navigate(LOGIN);
    }
  }, []);
  return (
    <>
      <Navbar />
      <CPSheetGeneralAnalyticsDash adminConfig={userConfig} ROOT_URL={ROOT_URL} />
    </>
  );
};

export default CPSheetGeneralAnalytics;
